export default {"src":"/_next/static/media/DownArrow.a0c69267.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};